import {
  createCurrencyFormatter,
  createFormatAmountInTemplate,
} from '../../utils/currency';
import { language, propertyLanguage } from '../../utils/language';

const currency = $('input#_currency').val();

export const formatAmount = createCurrencyFormatter({
  currency,
  language: propertyLanguage ?? language,
});

export const formatAmountInTemplate = createFormatAmountInTemplate({
  currency,
});

const dataLanguage = language === 'en' ? 'en-GB' : language;

export const formatDate = (date, { timeZone } = { timeZone: 'UTC' }) => {
  return (
    date
      .toLocaleString(dataLanguage, {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
      })
      // removes ',' after date eg. '05/07/2021, 11:30:35' -> '05/07/2021 11:30:35'
      .replace(',', '')
  );
};
